import type { BackgroundColor, Color } from '@onefootprint/design-tokens';
import { IcoInfo16, IcoWarning16 } from '@onefootprint/icons';
import type { InlineAlertVariant } from './inline-alert.types';

export const inlineAlertVariantStyles: Record<
  InlineAlertVariant,
  {
    backgroundColor: BackgroundColor;
    color: Color;
  }
> = {
  error: {
    backgroundColor: 'error',
    color: 'error',
  },
  info: {
    backgroundColor: 'info',
    color: 'info',
  },
  warning: {
    backgroundColor: 'warning',
    color: 'warning',
  },
  neutral: {
    backgroundColor: 'tertiary',
    color: 'tertiary',
  },
};

export const getIconForVariant = (variant: InlineAlertVariant) => {
  if (variant === 'error' || variant === 'warning') {
    return IcoWarning16;
  }
  return IcoInfo16;
};
